"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeParse = exports.cssObjectToAst = void 0;
const postcss_1 = __importDefault(require("postcss"));
const postcss_nested_1 = __importDefault(require("postcss-nested"));
const postcssJS = require('postcss-js');
const safeParser = require('postcss-safe-parser');
const postcssConfig = { parser: postcssJS };
const processor = postcss_1.default([postcss_nested_1.default()]);
function cssObjectToAst(cssObject, sourceFile = '') {
    return processor.process(cssObject, { from: sourceFile, ...postcssConfig });
}
exports.cssObjectToAst = cssObjectToAst;
function safeParse(css, options = { from: 'style.css' }) {
    return safeParser(css, options);
}
exports.safeParse = safeParse;
//# sourceMappingURL=parser.js.map